
export enum LongRunningTaskEventType {
  EVENT_INFO = 'EVENT_INFO',
  EVENT_SUCCESS = 'EVENT_SUCCESS',
  EVENT_FAILED = 'EVENT_FAILED',
  TASK_STARTED = 'TASK_STARTED',
  TASK_COMPLETED = 'TASK_COMPLETED',
  TASK_FAILED = 'TASK_FAILED'
}
